module.exports = __webpack_public_path__ + "img/17.62a44ac1.png";